<template>
    <wrapper>
        <main class="main-content-wrapper">
            <disposal-form
                title="Detail Disposal"
                subtitle="Informasi detail mengenai disposal barang."
                :form-data="formData"
                :channel-type-options="channelTypeOptions"
                :disabled="loadingPage"
                :status-badge="formData.statusDisposal"
                :validation-status="validationStatus"
                :validation-progress-data="validationProgressData"
                :loading-revalidate="loadingRevalidate"
                :showValidationProgress="true"
                @ambil-data="ambilData()"
                @validasi-ulang="revalidasiUlang()"
                @aksi-item="handleAksiItem"
                @get-validaition-progress="getValidationProgress()"
                @change-date="handleChangeDate"
            />

            <transaksi-disposal-card
                v-if="showTransaksiDisposal"
                class="mt-3"
                :transaksi-id-erp="formData.transaksiIdErp"
                :transaksi-id-jurnal="formData.transaksiIdJurnal"
                :err-erp-message="formData.errERPMessage"
                :err-jurnal-message="formData.errJurnalMessage"
                :loading="loadingBtnSubmit"
                @proses-ulang="submitDisposal()"
            />

            <div class="mt-3 d-flex justify-content-between">
                <button class="btn btn-outline-secondary back-btn" @click="$router.back()">
                    &#8592; Kembali
                </button>
                <div>
                    <button
                        v-if="allowDeleteDisposal && (formData.statusDisposal === 'pending' || formData.statusDisposal === 'draft') "
                        class="btn btn-outline-danger hapus-btn mr-2"
                        :disabled="loadingPage || loadingBtnDelete"
                        @click="hapusDisposal()"
                    >
                        {{ loadingBtnDelete ? 'Menghapus...' : 'Hapus Disposal' }}
                    </button>
                    <button
                        v-if="allowCreateDisposal && formData.statusDisposal == 'pending'"
                        class="btn btn-primary submit-btn"
                        :disabled="loadingPage || loadingBtnSubmit || !validationStatus.isValid"
                        @click="submitDisposal()"
                    >
                        {{ loadingBtnSubmit ? 'Menyimpan...' : 'Submit Disposal' }}
                    </button>
                    <!-- (formData.statusDisposal == 'failed' && ((formData.transaksiIdErp && formData.errErpMessage) || (formData.transaksiIdJurnal && formData.errJurnalMessage)) ) -->
                    <button
                        v-if="allowUpdateDisposal && (formData.statusDisposal == 'partial' || formData.statusDisposal == 'done')"
                        class="btn btn-outline-primary submit-btn"
                        :disabled="loadingBtnRevert"
                        @click="revertDisposal()"
                    >
                        {{ loadingBtnRevert ? 'Memproses...' : 'Revert Disposal' }}
                    </button>
                </div>
            </div>
        </main>

        <ModalCreateAssetId ref="modalCreateAssetId" @simpan="handleSaveAssetId" />
        <ModalChooseAssetId ref="modalChooseAssetId" @simpan="handleSaveAssetId" />
    </wrapper>
</template>

<script>
import swal from 'sweetalert';
import { Wrapper } from '../Layout';
import DisposalForm from './CustomComponent/DisposalForm.vue';
import ModalCreateAssetId from './CustomComponent/ModalCreateAssetId.vue';
import ModalChooseAssetId from './CustomComponent/ModalChooseAssetId.vue';
import TransaksiDisposalCard from './CustomComponent/TransaksiDisposalCard.vue';
import { alert } from "@/utils/alert";

export default {
    name: 'DisposalDetailPage',
    components: {
        Wrapper,
        DisposalForm,
        ModalCreateAssetId,
        ModalChooseAssetId,
        TransaksiDisposalCard,
    },
    data() {
        return {
            loadingPage: true,
            loadingBtnSubmit: false,
            loadingBtnDelete: false,
            loadingRevalidate: false,
            loadingBtnRevert: false,
            allowCreateDisposal:false,
            allowUpdateDisposal: false,
            allowDeleteDisposal:false,
            validationStatus: {
                isValid : false,
                failedItems: [],
            },
            // validationProgressData: {
            //     countInvalid : 0,
            //     countValid: 0,
            //     detailIdsInvalid : [],
            //     progressPercentage : '',
            //     totalComplete : 0,
            //     totalData : 0,
            // },
            validationProgressData:null,
            validationProgressInterval: null,
            validationPollingDone: false,
            disposeId: '',
            editDateDebounceTimer: null,
            formData: {
                channel: 'Marketplace',
                channelType: '',
                disposalDate: '',
                trxId: '',
                salesInvoiceId: '',
                statusDisposal: '',
                transaksiIdErp: '',
                transaksiIdJurnal: '',
                errERPMessage: '',
                errJurnalMessage: '',
                items: [],
                accessories: [],
            },
            channelTypeOptions: [],
        };
    },
    computed: {
        showTransaksiDisposal() {
            return !['draft', 'pending',''].includes((this.formData.statusDisposal || '').toLowerCase());
        },
    },
    methods: {
        getChannelTypes() {
            this.$http.get(process.env.DISPOSAL_GET_CHANNEL_TYPES,
            {
                headers: {'Asani-Token':localStorage.getItem('jwt')},
                timeout : 300 * 1000,
            })
            .then(response => {
                if(response.data.status !== 200 || response.status !== 200) {
                    alert({ confirmButtonColor: "blue" }).fire({
                        title: "Failed",
                        text: `${response.data.message}`,
                        icon: "error",
                    })
                    .then((result) => {});
                } else {
                   this.channelTypeOptions = response.data.data.marketplaces.map(marketplace => ({
                        type: marketplace,
                        typeName: marketplace,
                    }))
                }
                })
            .catch(error => {
                alert({ confirmButtonColor: "blue" }).fire({
                    title : 'Sorry',
                    text: `${error.response.data.message}`,
                    icon: "error",
                }).then((result) => {
                    if(error.response.data.status == 401) {
                        this.handleLogout()
                    }
                })
            })
        },
        cekPermission() {
            this.permission = localStorage.getItem('roles').replace(/"/g, "").replace("[", "").replace("]", "").split(",") 
            if(!this.permission.includes('26.1')) {
                this.$router.push('/');
            }
            if(this.permission.includes('26.2')) {
                this.allowUpdateDisposal = true
            }
            if(this.permission.includes('26.3')) {
                this.allowCreateDisposal = true
            }
            if(this.permission.includes('26.4')) {
                this.allowDeleteDisposal = true
            }
        },
        toInputDate(value) {
            if (!value) return '';
            const [day, month, year] = value.split('-');
            return `${year}-${month}-${day}`;
        },
        // Untuk Validasi Pertama Ketika masih draft
        ambilData(isRevalidation = false) {
            this.loadingBtnGetData = true;
            this.$http.post(process.env.GET_DISPOSAL_DATA_FROM_SHEET,{
                    channel : this.formData.channel,
                    marketplace: this.formData.channelType,
                    date: this.formData.disposalDate,
                    orderIdMarketPlace: this.formData.trxId,
                },{
                headers: {'Asani-Token':localStorage.getItem('jwt')},
                timeout : 300 * 1000,
            })
            .then(response => {
                if(response.data.status !== 200 || response.status !== 200) {
                    alert({ confirmButtonColor: "blue" }).fire({
                        title: "Failed",
                        text: `${response.data.message}`,
                        icon: "error",
                    })
                    .then((result) => {});
                    this.loadingBtnGetData = false
                    if (isRevalidation) this.loadingRevalidate = false
                } else {
                    this.getDetailData(isRevalidation)
                //    console.log(response.data.data.disposalId)
                }
                })
            .catch(error => {
                alert({ confirmButtonColor: "blue" }).fire({
                    title : 'Sorry',
                    text: `${error.response.data.message}`,
                    icon: "error",
                }).then((result) => {
                    if(error.response.data.status == 401) {
                        this.handleLogout()
                    } else {
                        this.loadingBtnGetData= false
                        if (isRevalidation) this.loadingRevalidate = false
                    }
                })
            })
        },
        getDetailData(isRevalidation = false) {
            this.loadingPage = true;
            this.$http
                .get(process.env.GET_DISPOSAL_DETAIL + this.$route.params.id, {
                    headers: { 'Asani-Token': localStorage.getItem('jwt') },
                })
                .then((response) => {
                    if (response.data.status === 200) {
                        const content = response.data.data;
                        this.formData = {
                            channel: content.channel === 'marketplace' ? 'Marketplace' : content.channel || '',
                            channelType: content.marketplace || '',
                            disposalDate: this.toInputDate(content.disposeDate),
                            trxId: content.invoiceMarketplace || '',
                            salesInvoiceId: content.salesInvoiceId || '',
                            statusDisposal: content.statusDisposal || '',
                            transaksiIdErp: content.transaksiIdErp || '',
                            transaksiIdJurnal: content.transaksiIdJurnal || '',
                            errERPMessage: content.errERPMessage || '',
                            errJurnalMessage: content.errJurnalMessage || '',
                            items: (content.items || []).map((item) => ({
                                name: item.itemNameGsheet,
                                erpName: item.itemName,
                                jurnalName: item.itemNameJurnal,
                                rows: (item.units || []).map((unit) => ({
                                    serialNumber: unit.serialNumber,
                                    assetId: unit.assetId,
                                    statusJurnal: unit.statusJurnal,
                                })),
                            })),
                            accessories: (content.accessories || []).map((accessory) => ({
                                itemCode: accessory.itemCode,
                                name: accessory.itemName,
                                qty: accessory.qty,
                            })),
                        };

                        this.validationStatus.failedItems = [...content.invalidItems]
                        this.validationStatus.isValid = content.isValid

                        if(!this.formData.transaksiIdErp && !this.formData.transaksiIdJurnal) {
                            this.checkDisposalReturn()
                        }
                    }
                    if (isRevalidation) this.loadingRevalidate = false
                    if (!this.validationPollingDone) {
                        this.getValidationProgress()
                    }
                    if (this.formData.statusDisposal === 'pending' && !this.validationPollingDone) {
                        this.startValidationProgressPolling()
                    } else {
                        this.stopValidationProgressPolling()
                    }
                    this.loadingPage = false;
                })
                .catch((error) => {
                    this.loadingPage = false;
                    if (isRevalidation) this.loadingRevalidate = false
                    const message =
                        (error.response && error.response.data && error.response.data.message) ||
                        'Gagal memuat data disposal';
                    swal('Sorry', message, 'error', { button: 'Ok' }).then(() => {
                        if (error.response && error.response.data && error.response.data.status === 401) {
                            this.handleLogout();
                        }
                    });
                });
        },
        // Untuk Validasi Kedua Ketika Statusnya sudah Pending
        do2ndValidation() {
            this.$http
                .post(process.env.DISPOSAL_REVALIDATE,{
                    disposeId : Number(this.$route.params.id)
                }, 
                {
                    headers: { 'Asani-Token': localStorage.getItem('jwt') },
                })
                .then((response) => {
                    if(response.data.status !== 200 || response.status !== 200) {
                    alert({ confirmButtonColor: "blue" }).fire({
                        title: "Failed",
                        text: `${response.data.message}`,
                        icon: "error",
                    })
                    .then((result) => {});

                    this.loadingRevalidate = false
                    } else {
                        // this.getDetailData(true)
                        window.location.reload()
                        this.loadingRevalidate = false
                    //    console.log(response.data.data.disposalId)
                    }
                })
                .catch((error) => {
                    this.loadingPage = false;
                    this.loadingRevalidate = false
                    const message =
                        (error.response && error.response.data && error.response.data.message) ||
                        'Gagal validasi data disposal';
                    swal('Sorry', message, 'error', { button: 'Ok' }).then(() => {
                        if (error.response && error.response.data && error.response.data.status === 401) {
                            this.handleLogout();
                        }
                    });
                });
        },
        startValidationProgressPolling() {
            this.stopValidationProgressPolling();
            this.validationProgressInterval = setInterval(() => {
                this.getValidationProgress();
            }, 10000);
        },
        stopValidationProgressPolling() {
            if (this.validationProgressInterval) {
                clearInterval(this.validationProgressInterval);
                this.validationProgressInterval = null;
            }
        },
        getValidationProgress(){
            if(this.formData.statusDisposal !== 'pending') {
                this.stopValidationProgressPolling();
                return
            }
            this.$http.get(`${process.env.DISPOSAL_GET_VALIDATION_PROGRESS}/${this.$route.params.id}`,
            {
                headers: {'Asani-Token':localStorage.getItem('jwt')},
                timeout : 300 * 1000,
            })
            .then(response => {
                if(response.data.status !== 200 || response.status !== 200) {
                    this.stopValidationProgressPolling();
                    alert({ confirmButtonColor: "blue" }).fire({
                        title: "Failed",
                        text: `${response.data.message}`,
                        icon: "error",
                    })
                    .then((result) => { this.validationProgressData = null});
                } else {
                   this.validationProgressData = {...response.data.data}
                   if (this.validationProgressData.totalComplete >= this.validationProgressData.totalData) {
                       this.validationPollingDone = true
                       this.stopValidationProgressPolling()
                       if (this.validationStatus.isValid) {
                           this.getDetailData()
                       }
                   }
                }
            })
            .catch(error => {
                this.stopValidationProgressPolling();
                const message = (error.response && error.response.data && error.response.data.message) || 'Gagal memuat progress validasi';
                alert({ confirmButtonColor: "blue" }).fire({
                    title : 'Sorry',
                    text: message,
                    icon: "error",
                }).then((result) => {
                    if(error.response && error.response.data && error.response.data.status == 401) {
                        this.handleLogout()
                    }
                })
            })
        },
        submitDisposal() {
            this.loadingBtnSubmit = true;
            this.$http.post(process.env.DISPOSAL_SUBMIT,{
                    disposeId: Number(this.$route.params.id),
                },{
                headers: {'Asani-Token':localStorage.getItem('jwt')},
                timeout : 300 * 1000,
            })
            .then(response => {
                if(response.data.status !== 200 || response.status !== 200) {
                    alert({ confirmButtonColor: "blue" }).fire({
                        title: "Failed",
                        text: `${response.data.message}`,
                        icon: "error",
                    })
                    .then((result) => {});
                    this.loadingBtnSubmit = false
                } else {
                    alert({ confirmButtonColor: "blue" }).fire({
                        title: 'Success',
                        text: `${response.data.message}`,
                        icon: 'success',
                    })
                    .then((result) => {
                        this.loadingBtnSubmit= false
                        this.toDisposalPage()
                    });
                }
            })
            .catch(error => {
                alert({ confirmButtonColor: "blue" }).fire({
                    title : 'Sorry',
                    text: `${error.response.data.message}`,
                    icon: "error",
                }).then((result) => {
                    if(error.response.data.status == 401) {
                        this.handleLogout()
                    } else {
                        this.loadingBtnSubmit= false
                    }
                })
            })
        },
        revalidasiUlang() {
            alert({ confirmButtonColor: "blue" }).fire({
                title: "Konfirmasi Validasi Ulang",
                text: "Pastikan data item disposal sudah diperbarui sebelum memproses validasi ulang.",
                icon: "warning",
                showCancelButton: true,
                reverseButtons: true,
                focusConfirm: false,
                confirmButtonText: "Validasi Ulang",
                cancelButtonText: "Kembali",
            }).then((result) => {
                if (result.isConfirmed) {
                    this.loadingRevalidate = true;
                    if(this.formData.statusDisposal == 'draft') {
                        this.ambilData(true);
                    } else {
                        this.do2ndValidation()
                    }
                    
                }
            });
        },
        handleChangeDate(newDate) {
            clearTimeout(this.editDateDebounceTimer);
            this.editDateDebounceTimer = setTimeout(() => {
                this.updateDisposalDate(newDate);
            }, 2000);
        },
        updateDisposalDate(newDate) {
            this.$http.post(process.env.DISPOSAL_EDIT_DATE,{
                    disposeId: Number(this.$route.params.id),
                    date: newDate,
                },{
                headers: {'Asani-Token':localStorage.getItem('jwt')},
                timeout : 300 * 1000,
            })
            .then(response => {
                if(response.data.status !== 200 || response.status !== 200) {
                    alert({ confirmButtonColor: "blue" }).fire({
                        title: "Failed",
                        text: `${response.data.message}`,
                        icon: "error",
                    })
                    .then((result) => {});
                } else {
                    alert({ confirmButtonColor: "blue" }).fire({
                        title: 'Success',
                        text: `${response.data.message}`,
                        icon: 'success',
                    })
                }
            })
            .catch(error => {
                alert({ confirmButtonColor: "blue" }).fire({
                    title : 'Sorry',
                    text: `${error.response.data.message}`,
                    icon: "error",
                }).then((result) => {
                    if(error.response.data.status == 401) {
                        this.handleLogout()
                    }
                })
            })
        },
        handleAksiItem(item) {
            if (item.action === 'set_asset_id') {
                this.$refs.modalCreateAssetId.showModal(item);
            } else if (item.action === 'pick_asset_id') {
                this.$refs.modalChooseAssetId.showModal(item);
            } else {
                swal(item.action.label, `Aksi untuk item ${item.reference} (${item.name}) belum terhubung ke sistem.`, 'info', {
                    button: 'Ok',
                });
            }
        },
        handleSaveAssetId({ item, assetId }) {
            const target = this.validationStatus.failedItems.find((failedItem) => failedItem === item);
            if (target) {
                target.assetId = assetId;
            }
            this.$http.post(process.env.DISPOSAL_RESOLVE,{
                    disposeId: Number(this.$route.params.id),
                    detailId : item.detailId,
                    jurnalAssetId : assetId,
                },{
                headers: {'Asani-Token':localStorage.getItem('jwt')},
                timeout : 300 * 1000,
            })
            .then(response => {
                if(response.data.status !== 200 || response.status !== 200) {
                    alert({ confirmButtonColor: "blue" }).fire({
                        title: "Failed",
                        text: `${response.data.message}`,
                        icon: "error",
                    })
                    .then((result) => {});
                    this.loadingBtnSubmit = false
                } else {
                    alert({ confirmButtonColor: "blue" }).fire({
                        title: 'Success',
                        text: `${response.data.message}`,
                        icon: 'success',
                    })
                    .then((result) => {
                        this.loadingBtnSubmit= false
                        this.$refs.modalCreateAssetId.closeModal();
                        this.$refs.modalChooseAssetId.closeModal();
                        window.location.reload()
                    });
                }
            })
            .catch(error => {
                alert({ confirmButtonColor: "blue" }).fire({
                    title : 'Sorry',
                    text: `${error.response.data.message}`,
                    icon: "error",
                }).then((result) => {
                    if(error.response.data.status == 401) {
                        this.handleLogout()
                    } else {
                        this.loadingBtnSubmit= false
                    }
                })
            })
        },
        hapusDisposal() {
            alert({ confirmButtonColor: "red" }).fire({
                title: "Konfirmasi Hapus Disposal",
                text: "Seluruh data dan proses pengajuan disposal ini akan dihapus dari sistem.",
                icon: "warning",
                showCancelButton: true,
                reverseButtons: true,
                focusConfirm: false,
                confirmButtonText: "Hapus Disposal",
                cancelButtonText: "Batal",
            }).then((result) => {
                if (result.isConfirmed) {
                    this.loadingBtnDelete = true;
                    this.disposalDeleteProcess()
                }
            });
        },
        disposalDeleteProcess() {
            this.$http
                .post(process.env.DISPOSAL_DELETE,{
                    disposeId : Number(this.$route.params.id)
                },
                {
                    headers: { 'Asani-Token': localStorage.getItem('jwt') },
            })
            .then((response) => {
                if (response.data.status !== 200) {
                     alert({ confirmButtonColor: "blue" }).fire({
                        title: "Failed",
                        text: `${response.data.message}`,
                        icon: "error",
                    })
                    .then((result) => {});
                    this.loadingBtnDelete = false      
                } else {
                    alert({ confirmButtonColor: "blue" }).fire({
                        title: 'Success',
                        text: `${response.data.message}`,
                        icon: 'success',
                    })
                    .then((result) => {
                        this.loadingBtnDelete= false
                        this.toDisposalPage()
                    });
                }

            })
            .catch((error) => {
                this.loadingBtnDelete = false
                const message =
                    (error.response && error.response.data && error.response.data.message) ||
                    'Gagal menghapus disposal';
                swal('Sorry', message, 'error', { button: 'Ok' }).then(() => {
                    if (error.response && error.response.data && error.response.data.status === 401) {
                        this.handleLogout();
                    }
                });
            });
        },
        revertDisposal() {
            alert({ confirmButtonColor: "blue" }).fire({
                title: "Konfirmasi Revert Disposal",
                html: 'Status disposal akan kembali ke <strong>Pending</strong>.<br>Data transaksi id ERP atau Jurnal yang tercatat akan dibatalkan/dihapus.',
                icon: "warning",
                showCancelButton: true,
                reverseButtons: true,
                focusConfirm: false,
                confirmButtonText: "Revert Disposal",
                cancelButtonText: "Batal",
            }).then((result) => {
                if (result.isConfirmed) {
                    this.doRevertDisposal();
                }
            });
        },
        doRevertDisposal() {
            this.loadingBtnRevert = true;
            this.$http.post(process.env.DISPOSAL_REVERT,{
                    disposeId: Number(this.$route.params.id),
                },{
                headers: {'Asani-Token':localStorage.getItem('jwt')},
                timeout : 300 * 1000,
            })
            .then(response => {
                if(response.data.status !== 200 || response.status !== 200) {
                    alert({ confirmButtonColor: "blue" }).fire({
                        title: "Failed",
                        text: `${response.data.message}`,
                        icon: "error",
                    })
                    .then((result) => {});
                    this.loadingBtnRevert = false
                } else {
                    alert({ confirmButtonColor: "blue" }).fire({
                        title: 'Success',
                        text: `${response.data.message}`,
                        icon: 'success',
                    })
                    .then((result) => {
                        this.loadingBtnRevert= false
                        window.location.reload()
                    });
                }
            })
            .catch(error => {
                alert({ confirmButtonColor: "blue" }).fire({
                    title : 'Sorry',
                    text: `${error.response.data.message}`,
                    icon: "error",
                }).then((result) => {
                    if(error.response.data.status == 401) {
                        this.handleLogout()
                    } else {
                        this.loadingBtnRevert= false
                    }
                })
            })
        },
        checkDisposalReturn() {
            this.$http.post(process.env.DISPOSAL_CHECK_RETURN,{
                    disposeId: Number(this.$route.params.id),
                },{
                headers: {'Asani-Token':localStorage.getItem('jwt')},
                timeout : 300 * 1000,
            })
            .then(response => {
                if(response.data.status !== 200 || response.status !== 200) {
                    alert({ confirmButtonColor: "blue" }).fire({
                        title: "Failed",
                        text: `${response.data.message}`,
                        icon: "error",
                    })
                    .then((result) => {});
                } 
            })
            .catch(error => {
                alert({ confirmButtonColor: "blue" }).fire({
                    title : 'Sorry',
                    text: `${error.response.data.message}`,
                    icon: "error",
                }).then((result) => {
                    if(error.response.data.status == 401) {
                        this.handleLogout()
                    }
                })
            })
        },
        toDisposalPage() {
            this.$router.push({
                path: '/disposal',
                query: {
                    disposalId: '',
                    disposalDate: '',
                    createdBy: '',
                    erpTrxId: '',
                    jurnalTrxId: '',
                    status: '',
                    page: 1,
                    itemPerPage: 10,
                }
            })
        },
        async handleLogout() {
            try {
                await this.$http.post(process.env.LOGOUT, {}, {
                    headers: { 'Asani-Token': localStorage.getItem('jwt') },
                });
            } catch (error) {
                if (error.response.data.status !== 401) return;
            }
            localStorage.removeItem('jwt');
            localStorage.removeItem('admin_name');
            localStorage.removeItem('roles');
            localStorage.removeItem('user_email');
            localStorage.removeItem('admin_id');
            this.$router.push('/');
        },
        cekLogin() {
            if (localStorage.getItem('jwt') == null) {
                this.$router.push('/');
            }
        },
    },
    created() {
        this.cekLogin();
        this.cekPermission()
        this.getChannelTypes();
        this.getDetailData();
        // this.getValidationProgress()
    },
    beforeDestroy() {
        this.stopValidationProgressPolling();
        clearTimeout(this.editDateDebounceTimer);
    },
};
</script>

<style scoped>
.main-content-wrapper {
    padding: 24px;
}

.back-btn {
    font-size: 13px;
    border-color: #dee2e6;
    color: #343a40;
    background: #fff;
    padding: 6px 16px;
}

.back-btn:hover {
    background-color: #f8f9fa;
}

.hapus-btn {
    font-size: 13px;
    padding: 6px 20px;
}

.submit-btn {
    font-size: 13px;
    padding: 6px 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Disposal/DisposalDetailPage.vue